export enum TermSettingsEnum {
  NeverExpires = 0,
  OneYear = 12,
  TwoYears = 24,
  ThreeYears = 36,
  Custom,
}
